<template>
  <div class="settle-accounts-info">
    <div class="settle-account-table">
      <vxe-grid
        border
        show-overflow
        show-footer
        :footer-method="footerMethod"
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @radio-change="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        height="300"
      >
        <!-- :checkbox-config="{ checkMethod: activeRowMethod }" -->
        <template v-slot:buttons v-if="isCreate">
          <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >引入费用</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="radio" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <!-- <template v-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</template> -->
            <!-- <template v-else-if="item.field === 'productType'">{{
              productList?.find((item) => item.value == row['productType'])?.label
            }}</template>
            <template v-else-if="item.field === 'serviceType'">{{
              serviceAllList?.find((item) => item.value == row['serviceType'])?.label
            }}</template> -->
            <!-- <span v-else-if="item.editRender.name == 'expenseType'">{{
              row['expenseTypeLabel']
            }}</span> -->
            <!-- <span v-else-if="item.editRender.name == 'expenseType'">{{
              expenseType?.find((item) => item.value == row['expenseType'])?.label
            }}</span> -->
            <!-- <span v-else-if="item.editRender.name == 'productCode'">{{
              productList?.find((item) => item.value == row['productCode'])?.label
            }}</span> -->
            <!-- <span v-else-if="item.editRender.name == 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</span> -->

            <span>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <!-- 费用编号 -->
            <!-- <el-input
              v-if="item.editRender.name == 'expenseNo'"
              v-model="row[item.field]"
              maxlength="20"
              @input="() => handleChange(row, item.field)"
            ></el-input> -->
            <!-- 费用类型 -->
            <!-- <el-select
              v-if="item.editRender.name == 'expenseType'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of expenseType"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select> -->

            <!-- 原币结算单价(含税) -->
            <!-- <el-input-number
              :precision="2"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'originalPrice'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number> -->
            <!-- 结算数量 -->
            <!-- <el-input-number
              :precision="2"
              :min="null"
              :controls="false"
              v-if="item.editRender.name == 'settlementQuantity'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number> -->
            <!-- 计量单位 -->
            <!-- <el-select
              v-if="item.editRender.name == 'unit'"
              filterable
              clearable
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) of basic_unit"
                :key="index"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select> -->
            <!-- 原币结算金额(含税) -->
            <!-- <el-input-number
              :precision="2"
              :controls="false"
              :min="null"
              v-if="item.editRender.name == 'originalAmount'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number> -->
            <!-- 币种 -->
            <el-select
              v-if="item.editRender.name == 'currencyCode'"
              filterable
              clearable
              disabled
              v-model="row[item.field]"
              @change="() => handleChange(row, item.field)"
            >
              <el-option
                v-for="(item, index) in currencyList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- 汇率 -->
            <!-- <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'exchangeRate'"
              disabled
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number> -->
            <!-- 本币结算金额（含税） -->
            <!-- <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'domesticAmount'"
              v-model="row[item.field]"
              disabled
              @input="() => handleChange(row, item.field)"
            ></el-input-number> -->

            <!-- 业务单据编号 -->
            <!-- <el-input
              v-if="item.editRender.name == 'businessDocNo'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)" 
            ></el-input> -->
            <!-- 税率 -->
            <el-input-number
              :precision="2"
              :controls="false"
              :min="0"
              v-if="item.editRender.name == 'taxRate'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
            <!-- 备注 -->
            <el-input
              v-if="item.editRender.name == 'remark'"
              v-model="row[item.field]"
              @input="(e) => handleChange(row, item.field)"
            ></el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>

      <IntroductionCostDialog ref="IntroductionCostDialog" @confirmHandler="confirmHandler" />
      <!-- @changePageHandler="changePageHandler" -->
    </div>
  </div>
</template>

<script>
  import API from '@/api/intermodality/order';
  import { tableColumnList, tableRules } from './index.js';
  import BASEAPI from '@/api/dataBase.js';
  import IntroductionCostDialog from '../IntroductionCostDialog/index.vue';
  export default {
    components: {
      IntroductionCostDialog,
    },
    name: 'SettleAccountsInfo',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      baseFormData: {
        type: Object,
        require: true,
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
      // 所有明细行
      lineDetailsList: {
        type: Array,
        default: () => [],
      },
      currentSettleAccountRowData: {
        type: Object,
        require: true,
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        currencyList: [],
        tableRules,
        tableColumnList,
        deleteLineDetailIds: [], //删除明细行的ids
        productList: [],
        serviceAllList: [],
      };
    },

    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            if (['domesticAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            return null;
          }),
        ];
      },
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          // console.log(item[field], '+item[field]00000000000');
          count += +item[field];
        });
        return count > 0 ? count.toFixed(2) : 0;
      },
      //是否可以编辑
      activeRowMethod({ columnIndex, row }) {
        if (['create'].includes(this.$route.query?.status) && this.$route.query?.id) {
          if (row?.id) {
            if (columnIndex == 15 || columnIndex == 22) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        } else {
          return this.isCreate;
        }
      },
      //校验
      async validAllEvent() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },
      //选择合同移除所有行
      removeRowHandler() {
        let deleteIds = this.getTableData().map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineDetailIds = this.deleteLineDetailIds.concat(deleteIds);
        this.$emit('saveDeleteLineDetailIds', this.deleteLineDetailIds);
        const $table = this.$refs.settleAccountsRef;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      // 新增行
      async newRowHandler() {
        // contractNo, orderCode
        this.$emit('_formatSettleAccountDto');
        const { currencyCode, currencyName, exchangeRate, contractNo } = this.baseFormData;
        if (!currencyCode || !currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }
        const { expenseType } = this.currentSettleAccountRowData;

        if (!expenseType) {
          this.$message.error('请补充结算行数据');
          return;
        }
        console.log('引入费用');
        setTimeout(() => {
          this.$refs.IntroductionCostDialog.lineDetailsList = this.lineDetailsList;
          this.$refs.IntroductionCostDialog.query.contractNo = contractNo;
          this.$refs.IntroductionCostDialog.query.expenseType = expenseType;
          this.$refs.IntroductionCostDialog.openModal();
        }, 50);

        // 先获取表单中的币种和汇率
        // const $table = this.$refs.settleAccountsRef;
        // const rowData = { currencyCode, currencyName, exchangeRate };
        // $table.setRadioRow(rowData);
        // this.insertEvent(rowData, 0);
      },
      confirmHandler(val) {
        // let newTableData = this.getTableData().concat(val);
        // const $table = this.$refs.settleAccountsRef;
        // $table.remove(this.getTableData()); //先删除表格所有数据
        // $table.insertAt(newTableData, 0);
        this.$emit('importData', val);
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(this.selectionList, 'this.selectionList');
        const xIDList = this.selectionList.map((item) => item.id);
        this.selectionList.map((item) => this.deleteLineDetailIds.push(+item.id));
        this.tableData = this.getTableData().filter((item) => !xIDList.includes(item.id));
        console.log(this.tableData, '删除this.tableData');
        this.$emit('deleteTableHandler', xIDList);
      },
      handleSelectionChange({ row }) {
        this.selectionList = [row];
        console.log(this.selectionList, '选择行');
        // this.$emit('selectHandler', this.selectionList);
      },
      handleChange(row, field) {
        if (field === 'currencyCode') {
          row['currencyName'] = this.currencyList?.find(
            (item) => item.value == row['currencyCode']
          )?.label;
        } else if (field === 'originalAmount') {
          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;
        } else if (field === 'periodDateFrom') {
          if (row['periodDateUntil'] !== null) {
            if (typeof row['periodDateUntil'] === 'number') {
              if (row['periodDateFrom'].getTime() > row['periodDateUntil']) {
                this.$message.error('开始时间不能大于结束时间');
                row['periodDateFrom'] = null;
              }
            } else {
              if (row['periodDateFrom'].getTime() > row['periodDateUntil'].getTime()) {
                this.$message.error('开始时间不能大于结束时间');
                row['periodDateFrom'] = null;
              }
            }
          }
        } else if (field === 'periodDateUntil') {
          if (row['periodDateFrom'] !== null) {
            if (typeof row['periodDateFrom'] === 'number') {
              if (row['periodDateUntil'].getTime() < row['periodDateFrom']) {
                this.$message.error('结束时间不能小于开始时间');
                row['periodDateUntil'] = null;
              }
            } else {
              if (row['periodDateUntil'].getTime() < row['periodDateFrom'].getTime()) {
                this.$message.error('结束时间不能小于开始时间');
                row['periodDateUntil'] = null;
              }
            }
          }
        } else if (field === 'originalPrice') {
          row['originalAmount'] =
            +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';

          // console.log(lineDetails, 'lineDetails999999999');
        } else if (field === 'settlementQuantity') {
          row['originalAmount'] =
            +(row['originalPrice'] * row['settlementQuantity']).toFixed(2) || '';
          row['domesticAmount'] = (row['originalAmount'] * row['exchangeRate']).toFixed(2) || 0;
        } else if (field === 'productName') {
          row['productName'] = this.productList?.find(
            (item) => item.value == row['productName']
          )?.label;
        } else if (field === 'taxRate') {
          row['originalAmountWithoutTax'] =
            (+row['originalAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['originalTaxAmount'] =
            (+row['originalAmount'] - +row['originalAmountWithoutTax']).toFixed(2) || '';

          row['domesticAmountWithoutTax'] =
            (+row['domesticAmount'] / (1 + +(row['taxRate'] ?? 0))).toFixed(2) || '';

          row['domesticTaxAmount'] =
            (+row['domesticAmount'] - +row['domesticAmountWithoutTax']).toFixed(2) || '';
        }
      },
      // 获取币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          this.currencyList = selectStatus.data.data.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      async closeEditTableHandler() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
        } else {
          // 派发事件
          const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
          const tableData = this.getTableData().map((item) => {
            return {
              ...item,
              currencyCode,
              currencyName,
              exchangeRate,
            };
          });
          this.tableData = tableData;
          this.$emit('closeEditTableHandler', tableData);
          await $table.clearActived();
        }
      },
      // 产品列表
      getProductList() {
        this.$axios
          .post(API.DATA_DICT, {
            dictType: 'INTERMODALITY-PRODUCT-TYPE',
            tenantCode: this.userInfo.tenantCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.productList = res.data.data || [];
              console.log(res.data.data, '产品');
            }
          });
      },
      // 服务列表
      getServiceList() {
        this.$axios
          .post(API.DATA_DICT, {
            dictType: 'INTERMODALITY-SERVICE-TYPE',
            tenantCode: this.userInfo.tenantCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.serviceAllList = res.data.data || [];
              console.log(res.data.data, '服务');
            }
          });
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },
    computed: {
      expenseType() {
        return this.dictListMap?.expenseType;
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          console.log(val, '子组件');
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.getCurrencyList();
      this.getProductList();
      this.getServiceList();
    },
  };
</script>

<style lang="scss" scoped>
  .settle-accounts-info {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
